
<script>
import dropdownIcon from '@/assets/images/icons/arrow-dropdown.svg?inline'

export default {
  name: 'rex-dropdown',
  components: {
    dropdownIcon
  },
  props: {
    name: {
      type: String,
      required: true
    },
    data: {
      type: Array,
      default: () => []
    },
    storeModule: {
      type: String,
      default: () => null,
      required: true
    },
    getterName: {
      type: String,
      default: () => null,
      required: true
    },
    setterName: {
      type: String,
      default: () => null,
      required: true
    },
    target: {
      type: String,
      default: () => null,
      required: true
    },
    position: {
      type: String,
      default: () => null,
      validator: pos => [
        'is-top-right',
        'is-top-left',
        'is-bottom-left'
      ].includes(pos)
    },
    customLabel: {
      type: Boolean,
      default: () => false
    },
    labelFormatter: {
      type: Function,
      default: () => null
    },
    cssClass: {
      type: String,
      default: () => null
    },
    disabled: {
      type: Boolean,
      default: () => false
    },
    showDropdownIcon: {
      type: Boolean,
      default: () => true
    },
    validate: {
      type: [String, Object],
      default: () => null
    },
  },
  inject: ['$validator'],
  computed: {
    value: {
      get() {
        return this.$store.getters[`${this.storeModule}/${this.getterName}`](this.target)
      },
      set(value) {
        this.$store.commit(`${this.storeModule}/${this.setterName}`, {
          target: this.target,
          value
        })

        this.$emit('onChange', value)
      }
    },
    error() {
      const target = this.target.split('.')
      const err = this.$store.getters[`${this.storeModule}/${this.getterName}`](`${target[0]}Errors`)
        .find(error => error.field === this.name)

      return err ? err.message : null
    },
    label() {
      let label = this.data.find(item => item.slug === this.value).name

      if (this.customLabel) {
        label = this.labelFormatter(label)
      }

      return label
    }
  },
}
</script>

<template>
  <div
    :class="cssClass"
    class="rex-dropdown"
  >
    <b-dropdown
      v-if="data.length"
      v-model="value"
      :position="position"
      :disabled="disabled"
    >
      <span
        slot="trigger"
        class="rex-dropdown__trigger"
      >
        {{ label }}
        <dropdown-icon
          v-if="showDropdownIcon"
          class="rex-dropdown__trigger-icon"
        />
      </span>
      <b-dropdown-item
        v-for="item in data"
        :key="item.slug"
        :value="item.slug"
      >
        {{ item.name }}
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>
